import React from "react";
import { Layout } from "antd";
import { ReactComponent as PartnerLogoIcon } from "../../../../assets/seller/icons/mobPartnerlogo_black.svg";
import Flag from "../../../../assets/seller/icons/national-flag.png";
import Globe from "../../../../assets/seller/icons/globe-icon.svg";
import linkedin from "../../../../assets/seller/icons/linkedin.svg";
import facebook from "../../../../assets/seller/icons/facebook.svg";
import instagram from "../../../../assets/seller/icons/instagram.svg";
import twitter from "../../../../assets/seller/icons/twitter.svg";

const { Footer } = Layout;

const FooterSection = React.memo(({ selectedValue, handleChange }) => (
  <Footer className="wow fadeInUp">
    <section className="footer-bottom-section d-none d-lg-block d-md-none">
      <div className="container">
        <div className="row">
          <div className="col-lg-2 col-12"><PartnerLogoIcon /></div>
          <div className="col-lg-4 col-12 d-flex justify-content-end"><div className="footer-bottom-box"><ul></ul></div></div>
          <div className="col-lg-6 col-12 d-flex justify-content-end">
            <div className="footer-bottom-box">
              <h3>Need help with something?</h3>
              <p>Call us:<a href="tel:+91 8660423608" className="number-style1">+91 8660423608</a></p>
              <p>Watsapp:<a href="https://api.whatsapp.com/send?phone=918970415365&amp;text=" className="number-style2">+91 8970415365</a></p>
              <p>Mail us:<a href="mailto:ask@madoverbuildings.com" className="number-style3">ask@madoverbuildings.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="footer-bottom-section d-block d-lg-none d-md-none">
      <div className="container"><div className="row">
        <div className="col-12"><PartnerLogoIcon /></div>
        <div className="col-6"><div className="footer-bottom-box footer-box-1mobile"><ul></ul></div></div>
        <div className="col-12"><div className="footer-bottom-box">
          <h3>Need help with something?</h3>
          <p>Call us:<a href="tel:8660423608" className="number-style1">+91 8660423608</a></p>
          <p>Watsapp:<a href="https://api.whatsapp.com/send?phone=918970415365&amp;text=" className="number-style2">+91 8970415365</a></p>
          <p>Mail us:<a href="mailto:ask@madoverbuildings.com" className="number-style3">ask@madoverbuildings.com</a></p>
        </div></div>
      </div></div>
    </section>
    <section className="border-section"><div className="container"><div className="row"><div className="col-lg-12"><div className="border-top-style"></div></div></div></div></section>
    <section className="footer-last-section d-none d-md-none d-xl-block d-lg-block">
      <div className="container"><div className="row">
        <div className="col-lg-6"><div className="row">
          <div className="col-lg-4 col-6"><div className="input-group footer-drop-down-style"><label className="input-group-text"><img src={Flag} alt="National Flag" /></label><select value={selectedValue} className="form-select" onChange={handleChange}><option value="0">India</option></select></div></div>
          <div className="col-lg-4 col-6"><div className="input-group footer-drop-down-style"><label className="input-group-text"><img src={Globe} alt="Globe Icon" /></label><select value={selectedValue} className="form-select" onChange={handleChange}><option value="0">English</option></select></div></div>
        </div></div>
        <div className="col-lg-6"><div className="footer-social-icon-style"><ul>
          <li className="desktop-style-text-folllow">Follow us on</li>
          <li><a href="https://www.linkedin.com/company/mad-over-buildings/" rel="noopener noreferrer" target="_blank"><img src={linkedin} alt="linkedin" /></a></li>
          <li><a href="https://m.facebook.com/madoverbuildings/" rel="noopener noreferrer" target="_blank"><img src={facebook} alt="facebook" /></a></li>
          <li><a href="https://www.instagram.com/madoverbuildings_mob/" rel="noopener noreferrer" target="_blank"><img src={instagram} alt="insta" /></a></li>
          <li><a href="https://twitter.com/mobforindia" rel="noopener noreferrer" target="_blank"><img src={twitter} alt="twitter" /></a></li>
        </ul></div></div>
        <div className="col-12"><p className="company-name-style">2024 by Madoverbuilding AI Private Limited</p></div>
      </div></div>
    </section>
    <section className="footer-last-section d-block d-lg-none d-md-none d-xl-none">
      <div className="container"><div className="row">
        <div className="col-lg-6"><div className="row">
          <div className="col-lg-4 col-6"><div className="input-group footer-drop-down-style"><label className="input-group-text"><img src={Flag} alt="National Flag" /></label><select className="form-select" value={selectedValue} onChange={handleChange}><option value="0">India</option></select></div></div>
          <div className="col-lg-4 col-6"><div className="input-group footer-drop-down-style"><label className="input-group-text"><img src={Globe} alt="Globe Icon" /></label><select value={selectedValue} className="form-select" onChange={handleChange}><option value="0">English</option></select></div></div>
        </div></div>
        <div className="col-lg-6"><div className="footer-social-icon-style"><p className="follows-on-top">Follow us on</p><ul>
          <li><a href="https://www.linkedin.com/company/mad-over-buildings/" rel="noopener noreferrer" target="_blank"><img src={linkedin} alt="linkedin" /></a></li>
          <li><a href="https://m.facebook.com/madoverbuildings/" rel="noopener noreferrer" target="_blank"><img src={facebook} alt="facebook" /></a></li>
          <li><a href="https://www.instagram.com/madoverbuildings_mob/" rel="noopener noreferrer" target="_blank"><img src={instagram} alt="instagram" /></a></li>
          <li><a href="https://twitter.com/mobforindia" rel="noopener noreferrer" target="_blank"><img src={twitter} alt="twitter" /></a></li>
        </ul></div></div>
        <div className="col-12"><p className="company-name-style">2024 by Madoverbuilding AI Private Limited</p></div>
      </div></div>
    </section>
  </Footer>
));

export default FooterSection;
